export default "__VITE_ASSET__CMpjgVA3__"